import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'

import { EnvironmentService } from 'app/environment.service'
import { AuthHttpService } from 'app/shared/auth-http.service'
import { ILoyaltyCardDeleteResult } from 'app/passengers/passengers.interfaces'
import { Observable } from 'rxjs'


@Injectable()
export class LoyaltyMatasService {

    constructor(
        private http: HttpClient,
        private authHttp: AuthHttpService,
        private environmentService: EnvironmentService,
    ) { }

    removeCardFromUserProfile(provider: number): Observable<ILoyaltyCardDeleteResult> {
        const url = `${this.environmentService.getOrchestrationUrl()}/loyalty/${provider}`
        return this.authHttp.delete<ILoyaltyCardDeleteResult>(url)
    }

}
